import { InputRef, Input, Flex } from 'antd';
import { FilterConfirmProps } from 'antd/es/table/interface';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { useRef } from 'react';
import './style.scss';

type TableFilterProps = {
  selectedKeys: React.Key[];
  confirm: (param?: FilterConfirmProps) => void;
  dataIndex: string;
  clearFilters?: () => void;
  close: () => void;
  setSelectedKeys: (selectedKeys: React.Key[]) => void;
  onSearch?: (data: {
    selectedKeys: React.Key[];
    searchedColumn: string;
    searchText: string;
  }) => void;
};

export const TableFilter = ({
  selectedKeys,
  confirm,
  dataIndex,
  clearFilters,
  setSelectedKeys,
  onSearch,
}: TableFilterProps) => {
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: string
  ) => {
    confirm();

    onSearch?.({
      selectedKeys,
      searchedColumn: dataIndex,
      searchText: selectedKeys[0],
    });
  };

  const handleReset = () => {
    clearFilters?.();
  };

  return (
    <div className='pj-search-filter' onKeyDown={(e) => e.stopPropagation()}>
      <Input
        autoComplete='off'
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() =>
          handleSearch(selectedKeys as string[], confirm, dataIndex)
        }
      />
      <Flex align='center' justify='space-between' gap={8}>
        <ButtonComponent
          appereance='secondary'
          onClick={handleReset}
          size='small'
          label='Clear'
        />

        <ButtonComponent
          appereance='primary'
          onClick={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          size='small'
          label='Search'
        />
      </Flex>
    </div>
  );
};
